import * as actionTypes from "../actions";
const initialState = { en: {}, ar: {} };

export function translationsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_TRANSLATIONS:
      return (state = action.payload);
    default:
      return state;
  }
}

export default translationsReducer;
